import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { leaveOrganization } from ".";

export function useLeaveOrganization() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.organisation._def,
        mutationFn: leaveOrganization,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.organisation._def,
                exact: false
            });
        }
    })
}